<script>
import WppConnectAPI from 'dashboard/routes/dashboard/settings/inbox/channels/WppConnectAPI';
import CommonWhatsappAPI from 'dashboard/routes/dashboard/settings/inbox/channels/commonWhatsapp/api';
import { useAlert } from 'dashboard/composables';
import commonWhatsappMixins from 'shared/mixins/commonWhatsappMixins';
import {
  DuplicateContactException,
  ExceptionWithMessage,
} from 'shared/helpers/CustomErrors';

export default {
  mixins: [commonWhatsappMixins],
  props: {
    contactInfo: {
      type: Object,
      default: () => {},
    },
    isCurrentUserAdm: {
      type: Boolean,
      default: false,
    },
    isCodeChat: {
      type: Boolean,
      default: false,
    },
    inbox: {
      type: Object,
      default: () => {},
    },
    currentContact: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDeleteConfirmationPopup: false,
      currentAPI: WppConnectAPI,
    };
  },
  mounted() {
    this.currentAPI = this.isCodeChat ? CommonWhatsappAPI : WppConnectAPI;
  },
  methods: {
    async promotionAction(isPromote) {
      this.$emit('onLoading');
      let target = this.contactInfo.phone;
      if (!target.includes('+')) target = '+' + target;
      const { data } = await this.currentAPI.setGroupUserAdmin(
        this.currentContact.id,
        this.inbox.phone_number,
        { target, promote: isPromote }
      );
      if (!data || !data.success) {
        useAlert(data.message || 'Falha ao atualizar permissão');
        this.$emit('updateContact');
        return;
      }
      useAlert('Sucesso ao atualizar permissão');
      this.$emit('updateContact');
    },
    // CONTACT FUNCTIONS
    async addContact() {
      try {
        let rawPhoneNumber = this.contactInfo.phone.replace(/\D/g, '');
        let contact = await this.filterContactByNumber(rawPhoneNumber);
        if (!contact) {
          contact = await this.$store.dispatch(
            'contacts/create',
            this.getContactObject(rawPhoneNumber)
          );
          useAlert(this.$t('CONTACT_FORM.SUCCESS_MESSAGE'));
        }
        this.openContactNewTab(contact.id);
      } catch (error) {
        if (error instanceof DuplicateContactException) {
          if (error.data.includes('phone_number')) {
            useAlert(this.$t('CONTACT_FORM.FORM.PHONE_NUMBER.DUPLICATE'));
          }
        } else if (error instanceof ExceptionWithMessage) {
          useAlert(error.data);
        } else {
          useAlert(this.$t('CONTACT_FORM.ERROR_MESSAGE'));
        }
      }
    },
    getContactObject(phoneNumber) {
      const contactItem = {
        name: this.getContactName(true),
        phone_number: `+${phoneNumber}`,
        avatar_url: this.contactInfo.img,
      };
      return contactItem;
    },
    async filterContactByNumber(phoneNumber) {
      const query = {
        attribute_key: 'phone_number',
        filter_operator: 'equal_to',
        values: [phoneNumber],
        attribute_model: 'standard',
        custom_attribute_type: '',
      };

      const queryPayload = { payload: [query] };
      const contacts = await this.$store.dispatch('contacts/filter', {
        queryPayload,
        resetState: false,
      });
      return contacts.shift();
    },
    openContactNewTab(contactId) {
      const accountId = window.location.pathname.split('/')[3];
      const url = `/app/accounts/${accountId}/contacts/${contactId}`;
      window.open(url, '_blank');
    },
    async removeMemberFromGroup(confirmation = false) {
      this.showDeleteConfirmationPopup = false;
      if (!confirmation) return;

      this.$emit('onLoading');
      let target = this.contactInfo.phone;
      if (!target.includes('+')) target = '+' + target;
      const { data } = await this.currentAPI.userControlInGroup(
        this.currentContact.id,
        this.inbox.phone_number,
        target,
        'remove'
      );
      if (!data || !data.success) {
        useAlert(data.message || 'Falha ao remover participante');
        return;
      }
      useAlert('Sucesso ao remover participante');
      this.$emit('updateContact');
    },
    getContactName(fullName = false) {
      let name = !this.contactInfo.name
        ? '+' + this.contactInfo.phone
        : this.contactInfo.name;
      if (this.contactInfo.inPlatform)
        name += `(${this.contactInfo.inPlatform.name})`;
      return fullName || name.length <= 35 ? name : name.slice(0, 35) + '...';
    },
  },
};
</script>

<template>
  <div v-if="!contactInfo.isMe" class="contact-container">
    <div class="contact-info">
      <div class="picture-container">
        <img
          :src="contactInfo.img ? contactInfo.img : defaultUnsetImage"
          :alt="contactInfo.name"
        />
      </div>
      <div class="name-container">
        <p :title="getContactName(true)">
          {{ getContactName() }}
        </p>
      </div>
    </div>
    <woot-delete-modal
      v-model:show="showDeleteConfirmationPopup"
      :on-close="
        () => {
          removeMemberFromGroup(false);
        }
      "
      :on-confirm="
        () => {
          removeMemberFromGroup(true);
        }
      "
      :title="$t('LABEL_MGMT.DELETE.CONFIRM.TITLE')"
      :message="
        'Você tem certeza de que deseja remover o participante ' +
        contactInfo.name +
        '?'
      "
      confirm-text="Remover Participante"
      reject-text="Cancelar"
    />
    <div
      class="actions-container"
      :style="[isCurrentUserAdm ? {} : { 'justify-content': 'flex-end' }]"
    >
      <div class="icon-buttons-container">
        <woot-button
          :disabled="isLoading"
          color-scheme="primary"
          @click.prevent="addContact"
        >
          <fluent-icon icon="search" class="search-icon" />
        </woot-button>
        <woot-button
          v-if="isCurrentUserAdm"
          color-scheme="alert"
          icon="delete"
          :is-loading="isLoading"
          @click.prevent="showDeleteConfirmationPopup = true"
        />
      </div>
      <template v-if="isCurrentUserAdm">
        <div class="ml-1">
          <woot-button
            v-if="!contactInfo.isAdm"
            color-scheme="secondary"
            :is-loading="isLoading"
            @click.prevent="
              () => {
                promotionAction(true);
              }
            "
          >
            Promover a Admin
          </woot-button>
          <woot-button
            v-if="contactInfo.isAdm"
            color-scheme="secondary"
            :is-loading="isLoading"
            @click.prevent="
              () => {
                promotionAction(false);
              }
            "
          >
            Remover da lista de Admins
          </woot-button>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
.contact-info {
  width: 500px;
  display: flex;
  align-items: center;
  .name-container {
    padding-left: 16px;
  }
  .picture-container {
    width: 100px;
    min-width: 100px;
    img {
      border-radius: 50%;
    }
  }
}
.actions-container {
  width: 400px;
  display: flex;
}
.contact-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
}
.contact-container:hover {
  background: #f4f4f4;
}
</style>
